/* eslint-disable no-prototype-builtins */
// @TODO using prototype builtins is a bad design pattern. See ESLint rule for details
import basetemplate from './templates/notification.hbs';

require(`./scss/${process.env.ENTRY_POINT}/notification.scss`); // eslint-disable-line import/no-dynamic-require

const RETURN_KEY = 13;
const SPACE_BAR = 32;
const DEFAULT_OPTIONS = {
  selector: 'document.body',
  id: '',
  title: '',
  style: '',
  autoFocus: false,
  destroyOnClose: true,
  hideOnInit: false,
  content: '',
  state: 'fixed',
  brand: 'mcom',
};

export default class Notification {
  /**
    @param {Object} options
    */
  constructor(options) {
    this.options = Object.assign({}, DEFAULT_OPTIONS, options);

    // NOTE: Setting defaults
    if (!this.options.hasOwnProperty('el')) {
      this.options.el = document.querySelector(this.options.selector);
    }

    // Note mcom notification uses a valid  class name ,but in some cases the keyword success is being sent.
    if (this.options.style === 'success' || this.options.style === 'Success') {
      this.options.style = 'valid';
    }


    // taking developer provided state attribute and creating state objects
    if (this.options.state === 'fixed') {
      this.options.state = {
        dynamic: false,
        persistent: false,
        overlay: false,
        absolute: false,
      };
    }

    if (this.options.state === 'persistent') {
      this.options.state = {
        dynamic: false,
        persistent: true,
        overlay: false,
        absolute: false,
      };
    }


    this.el = this.options.el;


    this.initializeNotification();

    // Initialize event Listeners
    this.keyHandler = this.KeyPressCallback.bind(this);
    this.closeHandler = this.closeCallback.bind(this);
    this.globalNoticeEventListener();
  }

  initializeNotification() {
    if (this.el) {
      const container = document.createElement('div');
      container.innerHTML = basetemplate({
        id: this.options.id,
        headline: this.options.title,
        message: this.options.content,
        notificationType: this.options.style,
        hideOnInit: this.options.hideOnInit,
        brand: this.options.brand,
        autoFocus: this.options.autoFocus,
        dynamic: this.options.state.dynamic,
        persistent: this.options.state.persistent,
        overlay: this.options.state.overlay,
        absolute: this.options.state.absolute,
      });

      this.el.insertBefore(container, this.el.firstElementChild);
      if (this.options.hideOnInit === true) {
        this.el.firstElementChild.classList.add('hide');
      } else {
        this.el.firstElementChild.classList.add('show');
        if (this.options.autoFocus) {
          this.el.querySelector(`#${this.options.id}`).focus();
        }
      }
    }
  }


  close() {
    // our element is the first child so let's remove it
    this.NotificationWrapper = this.el.firstElementChild;
    if (this.options.destroyOnClose === true) {
      if (this.NotificationWrapper !== null) {
        this.destroy();
        const { parentNode } = this.NotificationWrapper;
        if (parentNode) {
        // Fix for IE-11
          parentNode.removeChild(this.NotificationWrapper);
        }
      } else {
        throw Error('The el notification has been removed externally.Exiting close method');
      }
    } else if (!this.el.firstElementChild.classList.contains('hide')) {
      this.toggleVisibility();
    }
  }

  toggleVisibility() {
    if (this.el.firstElementChild.classList.contains('hide')) {
      this.el.firstElementChild.classList.remove('hide');
      this.el.firstElementChild.classList.add('show');
    } else {
      this.el.firstElementChild.classList.add('hide');
      this.el.firstElementChild.classList.remove('show');
    }
  }

  /**
   * Since we're retrofitting a div with a role=button we need to handle both the space and
   * enter logic respectively
   */
  keyPressEventHandler(e) {
    if (e.keyCode === RETURN_KEY || e.keyCode === SPACE_BAR) {
      if (e.target.classList.contains('close-grey-small')) {
        // NOTE: calling close() for fixed and overlay notifications
        this.close();
      }
    }
  }

  closeCallback(e) {
    if (e.target.classList.contains('close-grey-small')) {
      this.close();
    }
  }

  KeyPressCallback(e) {
    this.keyPressEventHandler(e);
  }


  destroy() {
    if (this.el !== null) {
      this.el.removeEventListener('click', this.closeHandler, true);

      this.el.removeEventListener('keydown', this.keyHandler, true);
    } else {
      throw Error('Your el is invalid.Destroy will not invoke');
    }
  }

  globalNoticeEventListener() {
    if (this.el !== null) {
      this.el.addEventListener('click', this.closeHandler, true);


      this.el.addEventListener('keydown', this.keyHandler, true);
    }
  }
}



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@component/notification/src/notification.js